"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsOwnerFilter = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var fuse_js_1 = __importDefault(require("fuse.js"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var StringManipulater_1 = require("@CommonFrontend/Utils/StringManipulater");
var Types_1 = require("Reports/Types");
var GetFullName_1 = require("@CommonFrontendBackend/Utils/GetFullName");
var ReportsOwnerFilter = function (props) {
    var buttonClassName = props.buttonClassName, buttonEndIcon = props.buttonEndIcon, sessionUser = props.sessionUser, selectedOwner = props.selectedOwner, usersList = props.usersList;
    var userDataStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore;
    var isAdmin = userDataStore.isAdmin;
    var conformedEntries = (0, react_1.useMemo)(function () {
        return conformEntries({
            sessionUserId: sessionUser._id,
            usersList: usersList,
            teams: [],
            canSelectOtherUsers: isAdmin,
        });
    }, [usersList, sessionUser._id, isAdmin]);
    var selectedOwnerEntry = conformedEntries.find(function (_a) {
        var _id = _a._id, ownerType = _a.ownerType;
        return selectedOwner._id === _id && selectedOwner.ownerType === ownerType;
    });
    return (react_1.default.createElement(kaleidoscope_1.Popover, { size: kaleidoscope_1.PopoverSize.Auto, position: kaleidoscope_1.PopoverPosition.Bottom, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ className: buttonClassName, type: kaleidoscope_1.ButtonType.Tertiary }, buttonProps),
            react_1.default.createElement(kaleidoscope_1.Avatar, { type: avatarTypeMapping.get(selectedOwner.ownerType) }),
            (0, GetFullName_1.buildName)(selectedOwnerEntry.firstName, selectedOwnerEntry.lastName),
            buttonEndIcon)); }, autoStack: true },
        react_1.default.createElement(FilterPopoverContent, __assign({}, props, { conformedEntries: conformedEntries }))));
};
exports.ReportsOwnerFilter = ReportsOwnerFilter;
var avatarTypeMapping = new Map([
    [Types_1.OwnerFilterType.USER, kaleidoscope_1.AvatarType.User],
    [Types_1.OwnerFilterType.TEAM, kaleidoscope_1.AvatarType.Team],
    [Types_1.OwnerFilterType.ACCOUNT, kaleidoscope_1.AvatarType.Account],
]);
var c = (0, BemBuilder_1.default)("owner-filter-popover-content");
var FilterPopoverContent = function (_a) {
    var selectedOwner = _a.selectedOwner, handleOwnerSelect = _a.handleOwnerSelect, conformedEntries = _a.conformedEntries;
    var _b = __read((0, react_1.useState)(""), 2), searchTerm = _b[0], setSearchTerm = _b[1];
    var fuseObject = (0, react_1.useMemo)(function () { return createFuse(conformedEntries); }, [conformedEntries]);
    var searchResults = (0, react_1.useMemo)(function () { return searchEntries(searchTerm, conformedEntries, fuseObject); }, [
        searchTerm,
        conformedEntries,
        fuseObject,
    ]);
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("search-input-container") },
            react_1.default.createElement(kaleidoscope_1.SearchInput, { className: c("search-input"), label: "User filter search", onChange: setSearchTerm, value: searchTerm, placeholder: "Type a name or email" })),
        react_1.default.createElement("div", { className: c("cards-container") }, searchResults.map(function (_a, index) {
            var _id = _a._id, firstName = _a.firstName, lastName = _a.lastName, displayEmail = _a.displayEmail, ownerType = _a.ownerType;
            return (react_1.default.createElement(kaleidoscope_2.UserCard, { className: c("user-card"), key: index, user: { firstName: firstName, lastName: lastName, email: displayEmail }, selected: selectedOwner._id === _id && selectedOwner.ownerType === ownerType, onClick: function () { return handleOwnerSelect({ _id: _id, ownerType: ownerType }); }, avatarType: avatarTypeMapping.get(ownerType) }));
        }))));
};
function conformEntries(_a) {
    var e_1, _b;
    var sessionUserId = _a.sessionUserId, usersList = _a.usersList, teams = _a.teams, canSelectOtherUsers = _a.canSelectOtherUsers;
    var allEntries = [];
    var sessionUser = usersList.find(function (u) { return u._id === sessionUserId; });
    if (sessionUser) {
        allEntries.push(conformUserEntry(sessionUser));
    }
    allEntries.push({
        _id: Types_1.EveryoneInAccountId,
        firstName: "Everyone in your account",
        displayEmail: (0, StringManipulater_1.pluralise)(usersList.length, "user"),
        ownerType: Types_1.OwnerFilterType.ACCOUNT,
    });
    if (canSelectOtherUsers) {
        var orderedUsersList = usersList.slice().sort(function (a, b) {
            if (a.email.toLowerCase() > b.email.toLowerCase()) {
                return 1;
            }
            return -1;
        });
        try {
            for (var orderedUsersList_1 = __values(orderedUsersList), orderedUsersList_1_1 = orderedUsersList_1.next(); !orderedUsersList_1_1.done; orderedUsersList_1_1 = orderedUsersList_1.next()) {
                var u = orderedUsersList_1_1.value;
                if (u._id !== sessionUserId) {
                    allEntries.push(conformUserEntry(u));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (orderedUsersList_1_1 && !orderedUsersList_1_1.done && (_b = orderedUsersList_1.return)) _b.call(orderedUsersList_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return allEntries;
}
function conformUserEntry(_a) {
    var _id = _a._id, firstName = _a.firstName, lastName = _a.lastName, email = _a.email;
    return {
        _id: _id,
        firstName: firstName,
        lastName: lastName,
        searchableEmail: email,
        displayEmail: email,
        ownerType: Types_1.OwnerFilterType.USER,
    };
}
function createFuse(conformedEntries) {
    var options = {
        keys: ["firstName", "lastName", "searchableEmail"],
        threshold: 0.7,
    };
    return new fuse_js_1.default(conformedEntries, options);
}
function searchEntries(searchTerm, conformedEntries, fusedEntries) {
    if (searchTerm.length === 0) {
        return conformedEntries;
    }
    return fusedEntries.search(searchTerm, { limit: 50 }).map(function (result) { return result.item; });
}
